import { OnBoardingPage } from "./OnBoardingPage";
import { i18n } from "../../i18n";
// @ts-ignore
import modalBgPrint from '../../images/modal-bg-print.webp';
// @ts-ignore
import modalBgGPX from '../../images/modal-bg-GPX.webp';
// @ts-ignore
import modalBgList from '../../images/modal-bg-list.webp';
// @ts-ignore
import modalBgPro from '../../images/modal-bg-PRO.webp';
// @ts-ignore
import modalBgPurchaseProPlus from '../../images/modal-bg-purchase-pro-plus.webp';
// @ts-ignore
import modalBg3dMaps from '../../images/modal-bg-3D.jpg';
// @ts-ignore
import modalBgMapStyles from '../../images/modal-bg-map-styles.jpg';
// @ts-ignore
import modalBgMeasurementTool from '../../images/modal-bg-trail-measurement-tool.jpg';
// @ts-ignore
import modalBgAccommodations from '../../images/modal-bg-accom.jpg';
// @ts-ignore
import modalBgAmenities from '../../images/modal-bg-amenities.jpg';
// @ts-ignore
import modalBgTrailReviews from '../../images/modal-bg-trail-reviews.jpg';
// @ts-ignore
import modalBgTrailStages from '../../images/modal-bg-trail-stages.jpg';
// @ts-ignore
import modalBgTrailMap from '../../images/modal-bg-view-map.jpg';
// @ts-ignore
import modalBgWaypoints from '../../images/modal-bg-waypoints.webp';

const t = (key: string): string => i18n.global.t(key);

export enum OnBoardingGoal {
  CreateAccountForPurchase = 'create_account_for_purchase',
  CreateAccountForGermany = 'create_account_for_germany',
  CreateAccountForGiftCard = 'create_account_for_gift_card',
  CreateAccount = 'create_account',
  DownloadGPX = 'download_gpx',
  ConnectToApps = 'connect_to_apps',
  DownloadPrintMaps = 'download_print_maps',
  Donate = 'donate',
  AddTrailToList = 'add_trail_to_list',
  CreatePlannedTrail = 'save_planned_trail',
  DownloadApp = 'download_app',
  MapStyles = 'map_styles',
  MeasurementTool = 'measurement_tool',
  Accommodations = 'accommodations',
  Amenities = 'amenities',
  TrailReviews = 'trail_reviews',
  TrailStages = 'trail_stages',
  TrailMap = 'trail_map',
  TrailPreview = 'trail_preview',
  Waypoints = 'waypoints',
  Reviews = 'reviews',
  ReviewUpdate = 'review_update',
  Likes = 'likes',
  RedeemVoucher = 'redeem_voucher',
  CompleteHike = 'complete_hike',
}

export class OnBoardingGoalUtility {
  onBoardingGoal: OnBoardingGoal

  constructor(onBoardingGoal: OnBoardingGoal) {
    this.onBoardingGoal = onBoardingGoal
  }

  static fromString(onBoardingGoal: string): OnBoardingGoalUtility {
    switch (onBoardingGoal) {
      case 'create_account_for_purchase':
        return new OnBoardingGoalUtility(OnBoardingGoal.CreateAccountForPurchase)
      case 'create_account_for_germany':
        return new OnBoardingGoalUtility(OnBoardingGoal.CreateAccountForGermany)
      case 'create_account':
        return new OnBoardingGoalUtility(OnBoardingGoal.CreateAccount)
      case 'download_gpx':
        return new OnBoardingGoalUtility(OnBoardingGoal.DownloadGPX)
      case 'connect_to_apps':
        return new OnBoardingGoalUtility(OnBoardingGoal.ConnectToApps)
      case 'download_print_maps':
        return new OnBoardingGoalUtility(OnBoardingGoal.DownloadPrintMaps)
      case 'donate':
        return new OnBoardingGoalUtility(OnBoardingGoal.Donate)
      case 'add_trail_to_list':
        return new OnBoardingGoalUtility(OnBoardingGoal.AddTrailToList)
      case 'save_planned_trail':
        return new OnBoardingGoalUtility(OnBoardingGoal.CreatePlannedTrail)
      case 'download_app':
        return new OnBoardingGoalUtility(OnBoardingGoal.DownloadApp)
      case 'map_styles':
        return new OnBoardingGoalUtility(OnBoardingGoal.MapStyles)
      case 'measurement_tool':
        return new OnBoardingGoalUtility(OnBoardingGoal.MeasurementTool)
      case 'accommodations':
        return new OnBoardingGoalUtility(OnBoardingGoal.Accommodations)
      case 'amenities':
        return new OnBoardingGoalUtility(OnBoardingGoal.Amenities)
      case 'trail_reviews':
        return new OnBoardingGoalUtility(OnBoardingGoal.TrailReviews)
      case 'trail_stages':
        return new OnBoardingGoalUtility(OnBoardingGoal.TrailStages)
      case 'trail_map':
        return new OnBoardingGoalUtility(OnBoardingGoal.TrailMap)
      case 'trail_preview':
        return new OnBoardingGoalUtility(OnBoardingGoal.TrailPreview)
      case 'waypoints':
        return new OnBoardingGoalUtility(OnBoardingGoal.Waypoints)
      case 'reviews':
        return new OnBoardingGoalUtility(OnBoardingGoal.Reviews)
      case 'review_update':
        return new OnBoardingGoalUtility(OnBoardingGoal.ReviewUpdate)
      case 'likes':
        return new OnBoardingGoalUtility(OnBoardingGoal.Likes)
      case 'redeem_voucher':
        return new OnBoardingGoalUtility(OnBoardingGoal.RedeemVoucher)
      case 'complete_hike':
        return new OnBoardingGoalUtility(OnBoardingGoal.CompleteHike)
    }
    throw Error('Invalid OnBoardingGoal')
  }

  requiresPro() {
    switch (this.onBoardingGoal) {
      case OnBoardingGoal.CreateAccountForPurchase:
        return false
      case OnBoardingGoal.CreateAccountForGermany:
        return false
      case OnBoardingGoal.CreateAccount:
        return false
      case OnBoardingGoal.DownloadGPX:
        return false
      case OnBoardingGoal.ConnectToApps:
        return false
      case OnBoardingGoal.DownloadPrintMaps:
        return true
      case OnBoardingGoal.Donate:
        return false
      case OnBoardingGoal.AddTrailToList:
        return false
      case OnBoardingGoal.CreatePlannedTrail:
        return false
      case OnBoardingGoal.DownloadApp:
        return false
      case OnBoardingGoal.MapStyles:
        return false
      case OnBoardingGoal.MeasurementTool:
        return true
      case OnBoardingGoal.Accommodations:
        return false
      case OnBoardingGoal.Amenities:
        return false
      case OnBoardingGoal.TrailReviews:
        return false
      case OnBoardingGoal.TrailStages:
        return true
      case OnBoardingGoal.TrailMap:
        return false
      case OnBoardingGoal.TrailPreview:
        return false
      case OnBoardingGoal.Waypoints:
        return false
      case OnBoardingGoal.Reviews:
        return false
      case OnBoardingGoal.ReviewUpdate:
        return false
      case OnBoardingGoal.Likes:
        return false
      case OnBoardingGoal.RedeemVoucher:
        return false
      case OnBoardingGoal.CompleteHike:
        return false
    }
  }

  title() {
    switch (this.onBoardingGoal) {
      case OnBoardingGoal.CreateAccountForPurchase:
        return t('utils.on_boarding_goal.create_account_for_purchase_title')
      case OnBoardingGoal.CreateAccountForGermany:
        return t('utils.on_boarding_goal.create_account_for_germany_title')
      case OnBoardingGoal.CreateAccount:
        return t('utils.on_boarding_goal.create_account_title')
      case OnBoardingGoal.DownloadGPX:
        return t('utils.on_boarding_goal.download_gpx_title')
      case OnBoardingGoal.ConnectToApps:
        return t('utils.on_boarding_goal.connect_to_apps_title')
      case OnBoardingGoal.DownloadPrintMaps:
        return t('utils.on_boarding_goal.download_print_maps_title')
      case OnBoardingGoal.Donate:
        return t('utils.on_boarding_goal.donate_title')
      case OnBoardingGoal.AddTrailToList:
        return t('utils.on_boarding_goal.add_trail_to_list_title')
      case OnBoardingGoal.CreatePlannedTrail:
        return t('utils.on_boarding_goal.create_planned_trail_title')
      case OnBoardingGoal.DownloadApp:
        return t('utils.on_boarding_goal.download_app_title')
      case OnBoardingGoal.MapStyles:
        return t('utils.on_boarding_goal.map_styles_title')
      case OnBoardingGoal.MeasurementTool:
        return t('utils.on_boarding_goal.measurement_tool_title')
      case OnBoardingGoal.Accommodations:
        return t('utils.on_boarding_goal.accommodations_title')
      case OnBoardingGoal.Amenities:
        return t('utils.on_boarding_goal.amenities_title')
      case OnBoardingGoal.TrailReviews:
        return t('utils.on_boarding_goal.trail_reviews_title')
      case OnBoardingGoal.TrailStages:
        return t('utils.on_boarding_goal.trail_stages_title')
      case OnBoardingGoal.TrailMap:
        return t('utils.on_boarding_goal.trail_map_title')
      case OnBoardingGoal.TrailPreview:
        return t('utils.on_boarding_goal.trail_preview_title')
      case OnBoardingGoal.Waypoints:
        return t('utils.on_boarding_goal.waypoints_title')
      case OnBoardingGoal.Reviews:
        return t('utils.on_boarding_goal.reviews_title')
      case OnBoardingGoal.ReviewUpdate:
        return t('utils.on_boarding_goal.review_update_title')
      case OnBoardingGoal.Likes:
        return t('utils.on_boarding_goal.likes_title')
      case OnBoardingGoal.RedeemVoucher:
        return t('utils.on_boarding_goal.redeem_voucher_title')
      case OnBoardingGoal.CompleteHike:
        return t('utils.on_boarding_goal.complete_hike_title')
    }
  }

  body() {
    switch (this.onBoardingGoal) {
      case OnBoardingGoal.CreateAccountForPurchase:
        return t('utils.on_boarding_goal.create_account_for_purchase_body')
      case OnBoardingGoal.CreateAccountForGermany:
        return t('utils.on_boarding_goal.create_account_for_germany_body')
      case OnBoardingGoal.CreateAccount:
        return t('utils.on_boarding_goal.create_account_body')
      case OnBoardingGoal.DownloadGPX:
        return t('utils.on_boarding_goal.download_gpx_body')
      case OnBoardingGoal.DownloadPrintMaps:
        return t('utils.on_boarding_goal.download_print_maps_body')
      case OnBoardingGoal.Donate:
        return t('utils.on_boarding_goal.donate_body')
      case OnBoardingGoal.AddTrailToList:
        return t('utils.on_boarding_goal.add_trail_to_list_body')
      case OnBoardingGoal.ConnectToApps:
        return t('utils.on_boarding_goal.connect_to_apps_body')
      case OnBoardingGoal.CreatePlannedTrail:
        return t('utils.on_boarding_goal.create_planned_trail_body')
      case OnBoardingGoal.DownloadApp:
        return t('utils.on_boarding_goal.download_app_body')
      case OnBoardingGoal.MapStyles:
        return t('utils.on_boarding_goal.map_styles_body')
      case OnBoardingGoal.MeasurementTool:
        return t('utils.on_boarding_goal.measurement_tool_body')
      case OnBoardingGoal.Accommodations:
        return t('utils.on_boarding_goal.accommodations_body')
      case OnBoardingGoal.Amenities:
        return t('utils.on_boarding_goal.amenities_body')
      case OnBoardingGoal.TrailReviews:
        return t('utils.on_boarding_goal.trail_reviews_body')
      case OnBoardingGoal.TrailStages:
        return t('utils.on_boarding_goal.trail_stages_body')
      case OnBoardingGoal.TrailMap:
        return t('utils.on_boarding_goal.trail_map_body')
      case OnBoardingGoal.TrailPreview:
        return t('utils.on_boarding_goal.trail_preview_body')
      case OnBoardingGoal.Waypoints:
        return t('utils.on_boarding_goal.waypoints_body')
      case OnBoardingGoal.Reviews:
        return t('utils.on_boarding_goal.reviews_body')
      case OnBoardingGoal.ReviewUpdate:
        return t('utils.on_boarding_goal.review_update_body')
      case OnBoardingGoal.Likes:
        return t('utils.on_boarding_goal.likes_body')
      case OnBoardingGoal.RedeemVoucher:
        return t('utils.on_boarding_goal.redeem_voucher_body')
      case OnBoardingGoal.CompleteHike:
        return t('utils.on_boarding_goal.complete_hike_body')
    }
  }

  image(page: OnBoardingPage) {
    switch (this.onBoardingGoal) {
      case OnBoardingGoal.CreateAccountForPurchase:
        return modalBgGPX
      case OnBoardingGoal.CreateAccountForGermany:
        return modalBgGPX
      case OnBoardingGoal.CreateAccount:
        return modalBgGPX
      case OnBoardingGoal.DownloadGPX:
        return modalBgGPX
      case OnBoardingGoal.ConnectToApps:
        return modalBgGPX
      case OnBoardingGoal.DownloadPrintMaps:
        return modalBgPrint
      case OnBoardingGoal.Donate:
        return modalBgGPX
      case OnBoardingGoal.AddTrailToList:
        return modalBgList
      case OnBoardingGoal.CreatePlannedTrail:
        return modalBgGPX
      case OnBoardingGoal.DownloadApp:
        return modalBgGPX
      case OnBoardingGoal.MapStyles:
        return modalBgMapStyles
      case OnBoardingGoal.MeasurementTool:
        return modalBgMeasurementTool
      case OnBoardingGoal.Accommodations:
        return modalBgAccommodations
      case OnBoardingGoal.Amenities:
        return modalBgAmenities
      case OnBoardingGoal.TrailReviews:
        return modalBgTrailReviews
      case OnBoardingGoal.TrailStages:
        return modalBgTrailStages
      case OnBoardingGoal.TrailMap:
        return modalBgTrailMap
      case OnBoardingGoal.TrailPreview:
        return modalBg3dMaps
      case OnBoardingGoal.Waypoints:
        return modalBgWaypoints
      case OnBoardingGoal.Reviews:
        return modalBgTrailReviews
      case OnBoardingGoal.ReviewUpdate:
        return modalBgTrailReviews
      case OnBoardingGoal.Likes:
        return modalBgTrailReviews
      case OnBoardingGoal.RedeemVoucher:
        return modalBgPro
      case OnBoardingGoal.CompleteHike:
        return modalBgTrailMap
    }
  }
}
